export const DEFAULT_CRM_TOKEN = 'x078pgbue2h';
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/logo.png`;
export const textLogoUrl = `${window.assetsLocation}/images/text_logo.png`;
export const secondaryLogoUrl = `${window.assetsLocation}/images/logo_.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const bannerMobileUrl = `${window.assetsLocation}/images/banner_2.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['5'];
export const faqArticleIds = ['6', '7', '8', '9', '10', '11', '12'];
